export const UserGroup = () => import("./UserGroup.vue");
export const OfficeAppointments = () => import("./OfficeAppointments.vue");
